<template lang="pug">
  div
    v-card-title.pa-3
      div.c1.basic600--text(v-if="item.delivery_at") {{ item.delivery_at | convertServerDate }}
      div.c1.basic600--text(v-else) {{ $t('ASAP') }}
      v-spacer
      v-icon(v-if="closable" size="20" color="basic500" @click="$emit('dismiss', item)") mdi-close-circle
    v-card-text.pa-0
      div.d-flex.px-4.pb-4.pt-1
        div.ml-2(style="width: 50px" align="center")
          v-img(:src="item.fulfilment ? item.fulfilment.meta_data.shipping_logo : item.extra_data.error.fulfilment ? item.extra_data.error.fulfilment.meta_data.shipping_logo : require('@/assets/image_placeholder.png')" contain max-width="50" max-height="32")
          div.d-flex.align-center.justify-center.mt-3(v-if="item.fulfilment")
            v-icon(v-if="item.fulfilment.meta_data.service_type === 'car'" size="14" color="basic600") mdi-car-side
            v-icon(v-else size="14" color="basic600") mdi-moped
            div.c1.basic600--text.ml-2 {{ item.fulfilment.meta_data.service_type }}
        div.pl-6
          div.c1.basic600--text &#35;{{ item.lead_rid }}
          div.p2.basic700--text.mt-1 {{ item.receiver_address.name }}
          div.mt-1
            div.p2.basic600--text.text-wrapper {{ item.receiver_address.address_1 }},
            div.p2.basic600--text.text-wrapper(v-if="item.receiver_address.address_2") {{ item.receiver_address.address_2 }}
        v-spacer
        div.d-flex.align-center
          slot(name="additionalButton")
      slot(name="additionalSpace")
      slot(name="additionalAction")
      v-divider.basic300.border-width(v-if="showDivider")
</template>

<script>
export default {
  name: 'OngoingItem',
  props: {
    closable: {
      type: Boolean
    },
    item: {
      type: Object,
      required: true
    },
    showDivider: {
      type: Boolean
    }
  }
}
</script>

<style scoped>
.border-width {
  border-width: 1.5px;
}
</style>

<i18n>
{
  "en": {
    "ASAP": "ASAP"
  },
  "id": {
    "ASAP": "ASAP"
  }
}
</i18n>